<template>
  <div
    :class="alertClasses"
    class="rounded-lg border p-4 my-4"
    role="alert"
    :aria-label="ariaLabel"
  >
    <div class="flex items-start gap-3">
      <Icon :name="iconName" size="20" :class="iconClasses" class="shrink-0 mt-0.5" />
      <div class="flex-1 text-sm leading-relaxed">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
interface Props {
  type?: 'info' | 'warning' | 'error' | 'success';
}

const props = withDefaults(defineProps<Props>(), {
  type: 'info',
});

const iconName = computed(() => {
  const iconMap = {
    info: 'tabler:info-circle',
    warning: 'tabler:alert-triangle',
    error: 'tabler:circle-x',
    success: 'tabler:circle-check',
  };
  return iconMap[props.type];
});

const ariaLabel = computed(() => {
  const labelMap = {
    info: 'Information',
    warning: 'Warning',
    error: 'Error',
    success: 'Success',
  };
  return labelMap[props.type];
});

const alertClasses = computed(() => {
  const classMap = {
    info: 'bg-muted border-border text-foreground',
    warning: 'bg-muted border-border text-foreground',
    error: 'bg-red-50 border-red-200 text-red-900 dark:bg-red-950/50 dark:border-red-800 dark:text-red-100',
    success: 'bg-muted border-border text-foreground',
  };
  return classMap[props.type];
});

const iconClasses = computed(() => {
  const classMap = {
    info: 'text-foreground',
    warning: 'text-foreground',
    error: 'text-red-600 dark:text-red-400',
    success: 'text-foreground',
  };
  return classMap[props.type];
});
</script>
